export default function App() {
const isMobile = window.innerWidth <= 768;
  const services = [
    {
      number: "01",
      title: "Crown Molding",
      description:
        "From classic profiles to contemporary lines, every cut is installed with tight joints and a clean finish.",
      bullets: [
        "Custom profiles",
        "Vaulted ceilings",
        "Multi-piece installs",
        "Paint-grade or stain-grade",
      ],
    },
    {
      number: "02",
      title: "Baseboards & Casing",
      description:
        "Sharp lines, smooth transitions, and trim details that give each room a finished, custom look.",
      bullets: [
        "Door casing",
        "Window trim",
        "Back-band details",
        "Scarf & cope joints",
      ],
    },
    {
      number: "03",
      title: "Wainscoting & Paneling",
      description:
        "Wall treatments that add warmth, depth, and architectural character to homes and commercial spaces.",
      bullets: [
        "Raised panel",
        "Board & batten",
        "Shiplap",
        "Full wall paneling",
      ],
    },
    {
      number: "04",
      title: "Custom Cabinetry",
      description:
        "Built-ins and storage solutions designed around the way you live and the space you actually have.",
      bullets: [
        "Mudroom storage",
        "Bookshelves",
        "Entertainment centers",
        "Closet systems",
      ],
    },
    {
      number: "05",
      title: "Staircase Finishing",
      description:
        "Railings, newel posts, treads, risers, and trim work that turn a staircase into a focal point.",
      bullets: [
        "Handrails",
        "Balusters",
        "Tread & riser finish",
        "Newel post details",
      ],
    },
    {
      number: "06",
      title: "General Carpentry",
      description:
        "Beyond finish work, we handle the structure behind the finish with reliable, detail-focused craftsmanship.",
      bullets: ["Framing", "Doors", "Decks", "Repairs & restoration"],
    },
  ];

  const portfolio = [
    { title: "Porch Ceiling & Columns", type: "Exterior Finish Carpentry" },
    { title: "Staircase Finishing & Wainscoting", type: "Interior Finishing" },
    {
      title: "Interior Build-Out & Finish Carpentry",
      type: "Commercial Interior",
    },
    {
      title: "Reclaimed Wood Feature Wall Installation",
      type: "Commercial Carpentry",
    },
    {
      title: "Custom Wood Cladding & Ceiling Installation",
      type: "Commercial Carpentry",
    },
    { title: "Exterior Siding & Home Addition", type: "General Carpentry" },
    { title: "Deck Installation & Flooring", type: "Deck & Exterior Work" },
    {
      title: "Coffered Ceiling Installation",
      type: "INTERIOR FINISH CARPENTRY",
    },
  ];

  return (
    <div
      style={{
        background: "#f3f1ee",
        color: "#27211c",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <header
        style={{
          borderBottom: "1px solid #dfd8d1",
          background: "#f3f1ee",
          position: "sticky",
          top: 0,
          zIndex: 50,
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="/logo.JPG"
              alt="RRN Carpentry Logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>

          <nav
            style={{
              display: "flex",
              gap: "48px",
              fontSize: "12px",
              textTransform: "uppercase",
              letterSpacing: "0.18em",
            }}
          >
            <a
              href="#process"
              style={{ color: "#7a6a5d", textDecoration: "none" }}
            >
              Process
            </a>
            <a
              href="#portfolio"
              style={{ color: "#7a6a5d", textDecoration: "none" }}
            >
              Portfolio
            </a>
            <a
              href="#inquiry"
              style={{ color: "#7a6a5d", textDecoration: "none" }}
            >
              Inquiry
            </a>
          </nav>

          <a
            href="#inquiry"
            style={{
              border: "1px solid #b79a7d",
              padding: "10px 18px",
              textDecoration: "none",
              color: "#7a5b43",
              fontSize: "11px",
              textTransform: "uppercase",
              letterSpacing: "0.18em",
            }}
          >
            Initiate a Project
          </a>
        </div>
      </header>

      <section
        style={{
          minHeight: "92vh",
          backgroundImage:
            "linear-gradient(rgba(20,16,12,0.35), rgba(20,16,12,0.15)), url('/hero.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center 30%",
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            width: "100%",
            padding: "0 24px 90px",
          }}
        >
          <div style={{ maxWidth: "560px", color: "white" }}>
            <p
              style={{
                fontSize: "13px",
                textTransform: "uppercase",
                letterSpacing: "0.3em",
                opacity: 0.8,
              }}
            >
              RRN Carpentry
            </p>
            <h1
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "clamp(48px, 8vw, 92px)",
                lineHeight: 0.95,
                fontWeight: 400,
                margin: "18px 0",
              }}
            >
              The Finish
              <span
                style={{ display: "block", fontStyle: "italic", opacity: 0.9 }}
              >
                is the
              </span>
              <span style={{ display: "block" }}>Beginning.</span>
            </h1>
            <p
              style={{
                fontSize: "20px",
                lineHeight: 1.7,
                opacity: 0.9,
                maxWidth: "620px",
              }}
            >
              Finish carpentry and custom craftsmanship in Danbury, Fairfield
              County, and surrounding areas. Clean, detail-driven work done
              right the first time.
            </p>

            <div
              style={{
                display: "flex",
                gap: "14px",
                flexWrap: "wrap",
                marginTop: "32px",
              }}
            >
              <a
                href="#inquiry"
                style={{
                  border: "1px solid rgba(255,255,255,0.7)",
                  padding: "14px 22px",
                  color: "white",
                  textDecoration: "none",
                  textTransform: "uppercase",
                  fontSize: "13px",
                  letterSpacing: "0.15em",
                }}
              >
                Initiate a Project
              </a>
              <a
                href="#portfolio"
                style={{
                  border: "1px solid rgba(255,255,255,0.35)",
                  padding: "14px 22px",
                  color: "white",
                  textDecoration: "none",
                  textTransform: "uppercase",
                  fontSize: "13px",
                  letterSpacing: "0.15em",
                }}
              >
                View Portfolio
              </a>
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          borderTop: "1px solid #ddd5ce",
          borderBottom: "1px solid #ddd5ce",
          background: "#f6f3ef",
        }}
      >
        <div
  style={{
    display: "grid",
    gridTemplateColumns:
      window.innerWidth <= 768 ? "1fr" : "repeat(2, minmax(0, 1fr))",
    gap: "10px 24px",
    marginTop: "18px",
  }}
>
          {[
            ["Fully Insured", "Liability & workers' compensation"],
            ["Licensed", "State of Connecticut"],
            ["Danbury, CT", "Serving Fairfield County"],
          ].map(([title, subtitle]) => (
            <div
              key={title}
              style={{ padding: "26px 24px", borderRight: "1px solid #ddd5ce" }}
            >
              <div style={{ fontSize: "20px", color: "#231d18" }}>{title}</div>
              <div
                style={{ marginTop: "6px", fontSize: "14px", color: "#796d63" }}
              >
                {subtitle}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section
        id="process"
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "90px 24px" }}
      >
        <p
          style={{
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "0.3em",
            color: "#8d7967",
          }}
        >
          Our Process
        </p>
        <h2
          style={{
            fontFamily: "Georgia, serif",
            fontSize: "clamp(42px, 7vw, 82px)",
            lineHeight: 1.05,
            fontWeight: 400,
            marginTop: "18px",
          }}
        >
          Finishing is not a step.
          <span
            style={{ display: "block", fontStyle: "italic", color: "#8f8983" }}
          >
            It is the entire philosophy.
          </span>
        </h2>

        <div style={{ marginTop: "60px", borderTop: "1px solid #ddd5ce" }}>
          {services.map((service) => (
            <div
  key={service.number}
  style={{
    display: "grid",
    gridTemplateColumns:
      window.innerWidth <= 768 ? "1fr" : "90px 1fr 2fr",
    gap: window.innerWidth <= 768 ? "14px" : "28px",
    borderBottom: "1px solid #ddd5ce",
    padding: "34px 0",
  }}
>
              <div
                style={{
                  fontSize: "14px",
                  letterSpacing: "0.2em",
                  color: "#a18162",
                }}
              >
                {service.number}
              </div>
              <h3
  style={{
    fontFamily: "Georgia, serif",
    fontSize: window.innerWidth <= 768 ? "28px" : "42px",
    fontWeight: 400,
    margin: 0,
    lineHeight: 1.1,
  }}
>
                {service.title}
              </h3>
              <div>
                <p
  style={{
    fontSize: window.innerWidth <= 768 ? "16px" : "19px",
    lineHeight: 1.8,
    color: "#5f5348",
    marginTop: 0,
  }}
>
                  {service.description}
                </p>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "10px 24px",
                    marginTop: "18px",
                  }}
                >
                  {service.bullets.map((item) => (
                    <div
                      key={item}
                      style={{ color: "#735f4d", fontSize: "15px" }}
                    >
                      • {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section
        id="portfolio"
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "90px 24px" }}
      >
        <p
          style={{
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "0.3em",
            color: "#8d7967",
          }}
        >
          Selected Work
        </p>
        <h2
          style={{
            fontFamily: "Georgia, serif",
            fontSize: "clamp(42px, 7vw, 82px)",
            lineHeight: 1.05,
            fontWeight: 400,
            marginTop: "18px",
          }}
        >
          The Portfolio
          <span
            style={{ display: "block", fontStyle: "italic", color: "#8f8983" }}
          >
            of Precision.
          </span>
        </h2>
        <p
          style={{
            fontSize: "19px",
            lineHeight: 1.8,
            color: "#61564b",
            maxWidth: "760px",
            marginTop: "24px",
          }}
        ></p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "24px",
            marginTop: "48px",
          }}
        >
          {portfolio.map((item, index) => (
            <div key={item.title}>
              <div
                style={{
                  aspectRatio: "4 / 5",
                  background: "linear-gradient(135deg,#d8d1cb,#f1ece7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#8a786a",
                  textTransform: "uppercase",
                  letterSpacing: "0.2em",
                  fontSize: "13px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "4 / 5",
                    overflow: "hidden",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={`/proj${index + 1}.jpg`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.4s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />

                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: "rgba(0,0,0,0)",
                      transition: "background 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "rgba(0,0,0,0.25)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "rgba(0,0,0,0)")
                    }
                  />
                </div>
              </div>
              <h3
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "32px",
                  fontWeight: 400,
                  margin: "18px 0 6px",
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  fontSize: "13px",
                  textTransform: "uppercase",
                  letterSpacing: "0.15em",
                  color: "#8a786a",
                  margin: 0,
                }}
              >
                {item.type}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "100px 24px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "0.3em",
            color: "#8d7967",
          }}
        >
          Begin
        </p>
        <h2
          style={{
            fontFamily: "Georgia, serif",
fontSize: isMobile ? "58px" : "clamp(42px, 7vw, 82px)",
            lineHeight: 1.05,
            fontWeight: 400,
            marginTop: "18px",
          }}
        >
          Every masterpiece starts
          <span
            style={{ display: "block", fontStyle: "italic", color: "#8f8983" }}
          >
            with a conversation.
          </span>
        </h2>
        <p
          style={{
            fontSize: "19px",
            lineHeight: 1.8,
            color: "#63574c",
            marginTop: "24px",
          }}
        >
          Tell us about your space, your vision, and your timeline. We will put
          together a plan that fits your home, business, and budget.
        </p>
      </section>

      <section id="inquiry" style={{ borderTop: "1px solid #ddd5ce" }}>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "90px 24px",
            display: "grid",
            gridTemplateColumns: "1.05fr 1fr",
            gap: "50px",
          }}
        >
          <div>
            <p
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.3em",
                color: "#8d7967",
              }}
            >
              Inquiry
            </p>
            <h2
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "clamp(42px, 7vw, 82px)",
                lineHeight: 0.95,
                fontWeight: 400,
                marginTop: "18px",
              }}
            >
              Initiate a Project.
            </h2>
            <p
              style={{
                fontSize: "19px",
                lineHeight: 1.8,
                color: "#61564b",
                maxWidth: "550px",
                marginTop: "24px",
              }}
            >
              Share the details of your project. The more precise the info, the
              easier it is to plan the right approach from the start.
            </p>

            <div
              style={{
                marginTop: "46px",
                paddingTop: "28px",
                borderTop: "1px solid #ddd5ce",
              }}
            >
              <p
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.3em",
                  color: "#8d7967",
                }}
              >
                Location
              </p>
              <p style={{ fontSize: "22px", marginTop: "10px" }}>
                Danbury, CT & Surrounding Areas
              </p>

              <p
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.3em",
                  color: "#8d7967",
                  marginTop: "28px",
                }}
              >
                Response Time
              </p>
              <p style={{ fontSize: "22px", marginTop: "10px" }}>
                Within 24 hours
              </p>

              <p
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.3em",
                  color: "#8d7967",
                  marginTop: "28px",
                }}
              >
                Credentials
              </p>
              <p style={{ fontSize: "22px", marginTop: "10px" }}>
                Fully Licensed & Insured — State of CT
              </p>
            </div>
          </div>

         <div
  style={{
    border: "1px solid #ddd5ce",
    background: "#f7f4f1",
    padding: isMobile ? "22px" : "34px",
  }}
>
            <div
              style={{
                marginBottom: "28px",
fontSize: isMobile ? "11px" : "14px",
                textTransform: "uppercase",
letterSpacing: isMobile ? "0.1em" : "0.15em",
                color: "#8b7765",
              }}
            >
              1 Contact &nbsp;&nbsp; 2 Project &nbsp;&nbsp; 3 Details
            </div>

            <form
              action="https://formspree.io/f/mdapyavy"
              method="POST"
              style={{ display: "grid", gap: "18px" }}
            >
              <input name="name" placeholder="Full Name *" style={inputStyle} />
              <input name="email" placeholder="Email *" style={inputStyle} />
              <input name="phone" placeholder="Phone" style={inputStyle} />
              <input
                name="project"
                placeholder="Project Type"
                style={inputStyle}
              />
              <textarea
                name="message"
                placeholder="Tell us about the space, timeline, and work you need."
                rows={6}
                style={textAreaStyle}
              />
              <button
                type="submit"
                style={{
                  border: "1px solid #c7b09b",
                  padding: "15px 20px",
                  background: "transparent",
                  color: "#83644d",
                  textTransform: "uppercase",
                  letterSpacing: "0.15em",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Send Inquiry
              </button>
            </form>
          </div>
        </div>
      </section>

      <footer style={{ background: "#141414", color: "white" }}>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "60px 24px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "40px",
          }}
        >
          <div>
            <div
              style={{
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="/logo.JPG"
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </div>
            <p
              style={{
                marginTop: "20px",
                fontSize: "18px",
                lineHeight: 1.8,
                color: "rgba(255,255,255,0.72)",
              }}
            >
              Master-level carpentry throughout Connecticut and surrounding
              areas. Detail-driven work from structure to finish.
            </p>
          </div>

          <div>
            <p
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.3em",
                color: "rgba(255,255,255,0.45)",
              }}
            >
              Navigation
            </p>
            <div style={{ marginTop: "18px", display: "grid", gap: "12px" }}>
              <a
                href="#process"
                style={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                }}
              >
                Process
              </a>
              <a
                href="#portfolio"
                style={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                }}
              >
                Portfolio
              </a>
              <a
                href="#inquiry"
                style={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                }}
              >
                Inquiry
              </a>
            </div>
          </div>

          <div>
            <p
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.3em",
                color: "rgba(255,255,255,0.45)",
              }}
            >
              Validation
            </p>
            <div
              style={{
                marginTop: "18px",
                display: "grid",
                gap: "12px",
                color: "rgba(255,255,255,0.8)",
              }}
            >
              <p style={{ margin: 0 }}>Fully Licensed — State of Connecticut</p>
              <p style={{ margin: 0 }}>
                Fully Insured — Liability & Workers' Comp
              </p>
              <p style={{ margin: 0 }}>
                Serving Danbury, CT & surrounding areas
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

const textAreaStyle: React.CSSProperties = {
  width: "100%",
  border: "1px solid #ddd5ce",
  background: "white",
  padding: "14px",
  fontSize: "17px",
  outline: "none",
  resize: "vertical",
  boxSizing: "border-box",
};
const inputStyle: React.CSSProperties = {
  width: "100%",
  border: "0",
  borderBottom: "1px solid #d5ccc4",
  background: "transparent",
  padding: "14px 0",
  fontSize: "17px",
  outline: "none",
};

